import {Module} from "../index";
import {Notification} from "./entity";
import {Notifier} from "@/modules/notifications/services/Notifier";
import {VueModule} from "@/modules/vue";
import messages from "./resources/messages";
import {routes} from "./resources/routes";

export class NotificationsModule extends Module {
  messages = messages;
  routes = routes;

  dependsOn = [
    VueModule,
  ];

  public entities = [
    Notification,
  ];

  protected register() {
    super.register();

    this.app.bind<Notifier>(Notifier).to(Notifier);
  }

  boot() {
    super.boot();
  }
}
